import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { IMAGES } from '../data/content';
export function Hero() {
  return <header className="relative w-full overflow-hidden bg-navy-950 px-4 pb-12 pt-9 sm:px-6 sm:pb-16 sm:pt-14" data-id="element-139" data-mp="9k0fvb7hqlr8">
      <div className="pointer-events-none absolute -left-24 top-0 h-72 w-72 rounded-full bg-violet-700/25 blur-3xl" aria-hidden="true" data-id="element-140" data-mp="4mrtszj81xkp" />
      <div className="pointer-events-none absolute -right-24 top-40 h-72 w-72 rounded-full bg-violet-600/15 blur-3xl" aria-hidden="true" data-id="element-141" data-mp="xae74zi94gkr" />

      <div className="relative mx-auto flex max-w-3xl flex-col items-center text-center" data-id="element-142" data-mp="s9gfzxf9kc74">
        <p className="font-display text-sm font-bold uppercase tracking-[0.25em] text-gold-400 sm:text-base" data-id="element-143" data-mp="nbooh4ij6s3g">
          Dra. Karito
        </p>

        <h1 className="mt-4 font-display text-[30px] font-black leading-[1.1] text-white sm:text-5xl" data-id="element-144" data-mp="382fhvvzgliim">
          Resuelve el diagnóstico y tratamiento de la{' '}
          <span className="text-violet-400" data-id="element-145" data-mp="3j9ahvf8c4u67">infertilidad masculina</span> con una ruta clínica clara
        </h1>

        <p className="mt-4 max-w-xl text-[15px] leading-relaxed text-white/75 sm:text-lg" data-id="element-146" data-mp="3o5j2h85axfkr">
          Deja de improvisar frente a un espermograma alterado y conviértete en el profesional que
          siempre sabe cuál es el siguiente paso.
        </p>

        <p className="mt-3 max-w-xl text-[13px] leading-relaxed text-white/55 sm:text-base" data-id="element-147" data-mp="30gzwiz9q5evu">
          Más de 1.000 profesionales de la salud ya confían en la Dra. Karito. Accede a una
          metodología clínica paso a paso para diagnosticar, tratar y acompañar a cada paciente con
          seguridad, criterio y respaldo científico.
        </p>

        <motion.img initial={{
        opacity: 0,
        y: 24
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.7,
        ease: 'easeOut'
      }} src={IMAGES.mockup} alt="Ruta Fertilidad Masculina: 6 tomos digitales y 5 bonos clínicos" className="mt-8 w-full max-w-2xl" data-id="element-148" data-mp="2vgllr9gqnqu4" />

        <div id="hero-cta" className="mt-6 w-full max-w-xl scroll-mt-24" data-id="element-149" data-mp="nbl0ygmt488c">
          <CtaButton pulse subline="" data-id="element-150" data-mp="n9i2d87l96s0" />
          <p className="mt-3 text-center text-[11px] font-medium leading-relaxed text-white/60 sm:text-sm" data-id="element-151" data-mp="ibgod1p0rxne">
            Descarga inmediata · Pago único · Acceso de por vida · Garantía de 7 días
          </p>
        </div>

        <div className="mt-6 flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-[11px] font-semibold text-white/60 sm:text-sm" data-id="element-152" data-mp="1azkqxecanulv">
          <span className="flex items-center gap-1.5" data-id="element-153" data-mp="112px38qyuidx">
            <ShieldCheckIcon className="h-4 w-4 text-gold-400" aria-hidden="true" data-id="element-154" data-mp="111ewfhsthqr1" />
            6 Tomos Clínicos
          </span>
          <span className="hidden h-1 w-1 rounded-full bg-white/25 sm:block" aria-hidden="true" data-id="element-155" data-mp="x37falufynfb" />
          <span data-id="element-156" data-mp="3lqui5yd6ip9t">5 Bonos Exclusivos</span>
          <span className="hidden h-1 w-1 rounded-full bg-white/25 sm:block" aria-hidden="true" data-id="element-157" data-mp="3hr3tc077qj7x" />
          <span data-id="element-158" data-mp="1x9uk28qzz9md">100% Digital</span>
        </div>
      </div>
    </header>;
}